import { html, LitElement } from 'lit';
import { DebugService } from '../../../shared/services/debug.service.js';

class RefiPersonalReview extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiPersonalReview');
  }

  static get properties() {
    return {
      firstName: { type: String, reflect: true },
      lastName: { type: String, reflect: true },
      dob: { type: String, reflect: true },
      lastFourSsn: { type: String },
      phoneNumber: { type: String },
      emailAddress: { type: String },
    };
  }

  render() {
    return html` <div>
      <fs-body-text id="checkout-name" variant="primary"
        ><span data-qm-encrypt
          >${this.firstName} ${this.lastName}</span
        ></fs-body-text
      >
      <fs-body-text id="checkout-dob" variant="primary"
        ><span data-qm-block
          >${this.maskDateOfBirth(this.dob)}</span
        ></fs-body-text
      >
      <fs-body-text id="checkout-last-four-ssn" variant="primary"
        ><span data-qm-block
          >${this.lastFourSsn ? `***-**-${this.lastFourSsn}` : ''}</span
        ></fs-body-text
      >
      <fs-body-text id="checkout-phone" variant="primary"
        ><span data-qm-encrypt>${this.phoneNumber}</span></fs-body-text
      >
      <fs-body-text id="checkout-email" variant="primary"
        ><span data-qm-encrypt>${this.emailAddress}</span></fs-body-text
      >
    </div>`;
  }

  maskDateOfBirth(dateOfBirth) {
    if (dateOfBirth !== '' && dateOfBirth !== undefined) {
      return `${dateOfBirth.substring(0, 3)}**${dateOfBirth.substring(5)}`;
    }

    return '';
  }
}

customElements.define('refi-personal-review', RefiPersonalReview);
